import type { ReactNode } from 'react';
import { useI18n } from './context';

/**
 * مقطعٌ نصّي بمقاطع متعددة (نصّ + رابط + نقطة) داخل صفحة RTL.
 *
 * العازل في resolve() يكفي للنصّ الواحد، لكن الفقرة التي تخلط نصّاً وعنصراً
 * يرتّب المتصفح مقاطعها بحسب اتجاه الفقرة (RTL) فيسبق الرابطُ تتمةَ الجملة.
 * هذا الغلاف يجعل ترتيب المقاطع LTR للإنجليزية وحدها — والفقرة تبقى RTL
 * ومحاذاتها كما هي، فلا يتزحزح شيء في التخطيط.
 */
export function TextRun({ children }: { children: ReactNode }) {
  const { lang } = useI18n();
  return <span dir={lang === 'en' ? 'ltr' : 'rtl'}>{children}</span>;
}
